import React from 'react'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import './org-dashboard.scss'

/**
 * An info icon that keyboard users can reach: it takes focus, and its definition opens on focus as well as hover.
 * The control is named "Definition" and the tooltip, which the tooltip associates with the control while it is open,
 * is its description, so the sentence is read once. Definitions are sentences, so the tooltip takes the wide
 * long-copy width rather than antd's narrow default.
 */
export const DefinitionTooltip: React.FC<{ text: string }> = ({ text }) => (
    <Tooltip title={text} trigger={['hover', 'focus']} classNames={{ root: 'wide-tooltip' }}>
        <span className="org-dashboard-definition-tooltip" tabIndex={0} role="button" aria-label="Definition">
            <InfoCircleOutlined aria-hidden="true" />
        </span>
    </Tooltip>
)
